module.exports = __webpack_public_path__ + "img/for-alcohol-test-ipad-iphone-small.db2d2251.png";